'use strict';

import ngResource from 'angular-resource';

class EventService {
  constructor($resource) {
    'ngInject';
    this.api = $resource(
      '/api/event/:id',
      { id: '@id' },
      {
        index: { method: 'GET', isArray: true },
        show : { method: 'GET', isArray: true }
      }
    );

    this.oem_api = $resource(
      '/api/oem/event/:id',
      { id: '@id' },
      {
        index: { method: 'GET', isArray: true },
        show : { method: 'GET', isArray: true }
      }
    );

    this.manage_api = $resource(
      '/:mode/api/event/:id',
      { id: '@id', mode: '@mode' },
      {
        show : { method: 'GET', isArray: true }
      }
    )
  }
}

export default angular.module('leptonApp.EventService', ['ngResource'])
  .service('EventService', ['$resource', EventService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/event/event.service.js